<template>
    <div id="MapModal" :class="(isDisplayed) ? 'displayed':''" @click.stop="preventBubbling()">
        <div class="modal_closebt" @click="closeModal()">Close</div>
        <div class="modal_head">
            <div class="head_title">
                {{ countryName }}
            </div>
            <div class="head_taxhaven" v-if="hasData">
                {{ taxHavenText }}
            </div>
            <div class="head_value" v-if="hasData">
                <div class="value_chip" :style="{backgroundColor: countryColor}"></div>
                <div class="value_text">
                    {{ countryValue }}
                </div>
            </div>
            <div class="head_text" v-if="hasData">
                {{ countryHeadText }}
            </div>
            <div class="head_text" v-else>
                No data
            </div>
        </div>

        <div class="modal_table" v-if="hasData" :data-dataset="datasetID">
            
            <table v-if="datasetID == 'global-profit' && !isTaxHaven" class="table_data">
                <tr class="head">
                    <th class="cell bordered">&nbsp;</th>
                    <th class="cell bordered">Profits lost ($, Bln)</th>
                    <th class="cell bordered">Tax revenue lost ($, Bln)</th>
                    <th class="cell">Tax revenue lost<br />(% of corporate tax revenue)</th>
                </tr>

                <tr v-for="(rowObj, rowInc) in globalProfitDataTable" :data-type="rowObj.type" :data-inc="rowInc" :data-oddeven="rowObj.oddEven" class="row">
                    <td class="bordered label">{{rowObj.label}}</td>
                    <td class="bordered datavalue">{{rowObj.data[0]}}</td>
                    <td class="bordered datavalue">{{rowObj.data[1]}}</td>
                    <td class="datavalue">{{rowObj.data[2]}}</td>
                </tr>
            </table>

            <table v-if="datasetID == 'global-profit' && isTaxHaven" class="table_data twocols">
                <tr v-for="(rowObj, rowInc) in globalProfitDataTableTaxHaven" class="row">
                    <td class="bordered">
                        <span v-html="rowObj.label"></span>
                    </td>
                    <td>
                        {{rowObj.value}}
                    </td>
                </tr>
            </table>

            <table v-if="datasetID == 'offshore-financial' && !isTaxHaven" class="table_data twocols threecols">
                <tr class="head">
                    <th class="cell bordered">&nbsp;</th>
                    <th class="cell bordered">Offshore Wealth<br />($, Billions)</th>
                    <th class="cell">Offshore Wealth<br />(% of GDP)</th>
                </tr>
                <tr v-for="(rowObj, rowInc) in offshoreFinancialDataTable" class="row">
                    <td class="bordered">
                        <span v-html="rowObj.label"></span>
                    </td>
                    <td class="bordered datavalue">
                        {{rowObj.value}}
                    </td>
                    <td class="datavalue">
                        {{rowObj.valuePct}}
                    </td>
                </tr>
            </table>
            <!--
            <table v-if="datasetID == 'offshore-financial' && isTaxHaven" class="table_data twocols threecols">
                <tr class="head">
                    <th class="cell bordered">&nbsp;</th>
                    <th class="cell bordered">Offshore Wealth<br />($, Billions)</th>
                    <th class="cell">Offshore wealth held in tax haven<br />as a share of region's GDP (% of GDP)</th>
                </tr>
                <tr v-for="(rowObj, rowInc) in offshoreFinancialDataTableTaxHaven" class="row">
                    <td class="bordered">
                        <span v-html="rowObj.label"></span>
                    </td>
                    <td class="bordered datavalue">
                        {{rowObj.value}}
                    </td>
                    <td class="datavalue">
                        {{rowObj.valuePct}}
                    </td>
                </tr>
            </table>
            -->

            <table v-if="datasetID == 'offshore-real-estate'" class="table_data">
                <tr class="head">
                    <th class="cell bordered">&nbsp;</th>
                    <th class="cell bordered">Offshore real estate owned as a share of country’s GDP (in %)</th>
                    <th class="cell bordered">Total offshore real estate owned<br />(in  B$)</th>
                    <th class="cell">Share of total offshore real estate in city owned<br />(in %)</th>
                </tr>

                <tr v-for="(rowObj, rowInc) in offshoreRealEstateDataTable" :data-type="rowObj.type" :data-inc="rowInc" :data-oddeven="rowObj.oddEven" class="row">
                    <td class="bordered label">{{rowObj.label}}</td>
                    <td class="bordered datavalue">{{rowObj.data[0]}}</td>
                    <td class="bordered datavalue">{{rowObj.data[1]}}</td>
                    <td class="datavalue">{{rowObj.data[2]}}</td>
                </tr>
            </table>


            <div class="table_effective_tax" v-if="datasetID == 'effective-tax'">
                <div class="table_encart">
                    Effective tax rates (% of total)
                </div>

                <table class="table_data fivecols">
                    <tr class="head">
                        <th class="cell bordered">Variable</th>
                        <th class="cell bordered">Country value<br />(Year {{selectedYear}})</th>
                        <th class="cell bordered">Country mean<br />(full period)</th>
                        <th class="cell bordered">{{countryRegionName}} average<br />(Year {{selectedYear}})</th>
                        <!-- <th class="cell">Income average<br />(Year {{selectedYear}})</th> -->
                    </tr>

                    <tr v-for="(rowObj, rowInc) in effectiveTaxDataTable" :data-type="rowObj.type" :data-inc="rowInc" :data-oddeven="rowObj.oddEven" class="row">
                        <td class="bordered label">{{rowObj.label}}</td>
                        <td class="bordered datavalue">{{rowObj.data[0]}}</td>
                        <td class="bordered datavalue">{{rowObj.data[1]}}</td>
                        <td class="datavalue">{{rowObj.data[2]}}</td>
                        <!-- <td>{{rowObj.data[3]}}</td> -->
                    </tr>
                </table>

                <div class="table_encart encart2">
                    decomposition tax revenue in year {{selectedYear}} (% of total)
                </div>

                <table class="table_data sevencols">
                    <tr class="head">
                        <th class="cell bordered">Tax category</th>
                        <th class="cell bordered">Personal income tax</th>
                        <th class="cell bordered">Corporate income tax</th>
                        <th class="cell bordered">Payroll tax</th>
                        <th class="cell bordered">Property tax</th>
                        <th class="cell bordered">Indirect tax</th>
                        <th class="cell">Other taxes</th>
                    </tr>

                    <tr v-for="(rowObj, rowInc) in effectiveTaxDataTable2" :data-type="rowObj.type" :data-inc="rowInc" :data-oddeven="rowObj.oddEven" class="row">
                        <td class="bordered label">{{rowObj.label}}</td>
                        <td class="bordered datavalue">{{rowObj.data[0]}}</td>
                        <td class="bordered datavalue">{{rowObj.data[1]}}</td>
                        <td class="bordered datavalue">{{rowObj.data[2]}}</td>
                        <td class="bordered datavalue">{{rowObj.data[3]}}</td>
                        <td class="bordered datavalue">{{rowObj.data[4]}}</td>
                        <td class="datavalue">{{rowObj.data[5]}}</td>
                    </tr>
                </table>
            </div>

        </div>
    </div>
</template>

<script>

import {_} from 'underscore'
var slugify = require("underscore.string/slugify")
import * as UTILS from '~/commons/utils/index.js'

export default {
    props: {

        countryTooltipData: {
            default: function () {
                return {}
            }
        },

        isShow: {
            default: function (){
                return false
            }
        },

        datasetID: {
            default: function (){
                return ""
            }
        },

        countriesMapData: {
            default: function (){
                return []
            }
        },

        countryDBDataset: {
            default: function (){
                return {}
            }
        },

        countryDB: {
            default: function (){
                return {}
            }
        },

        selectedYear: {
            default: function (){
                return ""
            }
        },

        DBEffectiveTax: {
            default: function (){
                return {}
            }
        },

        DBProfitShiftingTaxHavenTooltipData: {
            default: function (){
                return {}
            }
        },

        indicatorObj: {
            default: function (){
                return {}
            }
        },

        counterpartObj: {
            default: function (){
                return {}
            }
        },
        mapShowTaxHavens: {
            default: function (){
                return false
            }
        }
    },
    data: function () {
        return {
            type: "country",
            isDisplayed: false,
            isTaxHaven: false,
            hasData: true,
            countryObj: {},
            countryName: "",
            countryValue: "",
            countryColor: "",
            countryHeadText: "",
            countryRegionName: "",
            taxHavenText: "Non-tax haven country",

            globalProfitDataTable: [],
            globalProfitDataTableTaxHaven: [],
            offshoreFinancialDataTable: [],
            offshoreFinancialDataTableTaxHaven: [],
            offshoreRealEstateDataTable: [],
            effectiveTaxDataTable: [],
            effectiveTaxDataTable2: []
        }
    },

    mounted: function () {
        this.isDisplayed = this.isShow;
    },

    methods: {
        openModal: function (modalType){
            this.type = modalType;
            this.isOpen = true;
        },

        closeModal: function (){
            this.isOpen = false;
        },

        updateModal: function (){
            var self = this;
            this.isTaxHaven = false;
            this.hasData = true;

            if(this.countryTooltipData.id != undefined && this.countryTooltipData.id != ""){
                this.countryObj = JSON.parse(JSON.stringify(UTILS.DB_COUNTRIES_OBJ[this.countryTooltipData.id]));
                this.countryName = this.countryObj.country_name;
                this.countryColor = this.countryTooltipData.color;
                this.countryRegionName = this.countryObj.regionname;

                var countryMapData = _.find(this.countriesMapData.countries, function (o){
                    return o.countryCode == self.countryTooltipData.id;
                })

                if(self.countryDBDataset.indicators == undefined || countryMapData == undefined){
                    this.hasData = false;
                    return;
                }

                if(this.datasetID == "global-profit"){
                    if(this.countryDB["Tax_haven_profit_shifting"] == "no"){
                        var rowsObj = {};
                        this.taxHavenText = "Non-tax haven country | " + self.selectedYear;
                        rowsObj["EU_Havens"] = {
                            type: "group",
                            oddEven: "none",
                            label: "EU Tax Havens",
                            data:[ 
                                UTILS.formatNumber(self.countryDBDataset.indicators["profits_shifted"].counterparts["EU_Havens"].years[self.selectedYear].value,2),
                                UTILS.formatNumber(self.countryDBDataset.indicators["tax_lost"].counterparts["EU_Havens"].years[self.selectedYear].value,2),
                                UTILS.formatNumber(self.countryDBDataset.indicators["corp_tax_lost"].counterparts["EU_Havens"].years[self.selectedYear].value,2,"%"),
                            ]
                        }

                        rowsObj["Non_EU_Havens"] = {
                            type: "group",
                            oddEven: "none",
                            label: "Non-EU Tax Havens",
                            data:[ 
                                UTILS.formatNumber(self.countryDBDataset.indicators["profits_shifted"].counterparts["Non_EU_Havens"].years[self.selectedYear].value,2),
                                UTILS.formatNumber(self.countryDBDataset.indicators["tax_lost"].counterparts["Non_EU_Havens"].years[self.selectedYear].value,2),
                                UTILS.formatNumber(self.countryDBDataset.indicators["corp_tax_lost"].counterparts["Non_EU_Havens"].years[self.selectedYear].value,2,"%"),
                            ]
                        }

                        _.each(self.countryDBDataset.indicators, function (indicatorObj, indicatorID){
                            var yearlyCounterparts = _.filter(indicatorObj.extended, function (o){
                                return o.year == self.selectedYear;
                            });

                            _.each(yearlyCounterparts, function (o){
                                if(rowsObj[o.counterpartExtended] == undefined){
                                    rowsObj[o.counterpartExtended] = {
                                        oddEven: "none",
                                        type: (o.counterpartExtended == "World") ? "group" : "country",
                                        label: (o.counterpartExtended == "World") ? "All Tax Havens" : o.counterpartExtended,
                                        counterpart: o.counterpart,
                                        data:[]
                                    };
                                }

                                var dataIndex = 0;
                                var unit = "";
                                if(indicatorID == "corp_tax_lost"){
                                    dataIndex = 2;
                                    unit = "%";
                                }
                                else if(indicatorID == "tax_lost") dataIndex = 1;

                                rowsObj[o.counterpartExtended].data[dataIndex] = UTILS.formatNumber(o.value, 2, unit);
                            })
                        })

                        var EUHavensRows = _.filter(rowsObj, function (o){ return o.counterpart == "EU_Havens"; });
                        var NonEUHavensRows = _.filter(rowsObj, function (o){ return o.counterpart == "Non_EU_Havens"; });
                        var tableRows = [];
                        //self.countryValue = rowsObj["World"].data[2]+"%";
                        var dataYearsObj = self.countryDBDataset.indicators[self.indicatorObj.id].counterparts[self.counterpartObj.id];
                        if(self.indicatorObj.smallUnit == "%"){
                            self.countryValue = UTILS.formatNumber(dataYearsObj.years[self.selectedYear].value, 2, "%");
                        } else {
                            self.countryValue = UTILS.formatNumber(dataYearsObj.years[self.selectedYear].value, 2);
                        }

                        self.countryValue = self.countryValue + self.indicatorObj.smallUnit;
                        self.countryHeadText = self.countryName + " loses "+ self.countryValue + " " + self.indicatorObj.modalLabel;

                        if(rowsObj["World"] != undefined){
                            tableRows.push(rowsObj["World"]);
                        } else {
                            rowsObj["World"] = {
                                type: "group",
                                oddEven: "none",
                                label: "All Tax Havens",
                                data:[ 
                                    UTILS.formatNumber(self.countryDBDataset.indicators["profits_shifted"].counterparts["World"].years[self.selectedYear].value,2),
                                    UTILS.formatNumber(self.countryDBDataset.indicators["tax_lost"].counterparts["World"].years[self.selectedYear].value,2),
                                    UTILS.formatNumber(self.countryDBDataset.indicators["corp_tax_lost"].counterparts["World"].years[self.selectedYear].value,2,"%"),
                                ]
                            }
                            tableRows.push(rowsObj["World"]);
                        }
                        tableRows.push(rowsObj["EU_Havens"]);

                        var oddEven = "odd";
                        _.each(EUHavensRows, function (o){
                            o.oddEven = oddEven;
                            if(oddEven == "odd") oddEven = "even";
                            else oddEven = "odd";
                            tableRows.push(o);
                        })
                        tableRows.push(rowsObj["Non_EU_Havens"]);
                        _.each(NonEUHavensRows, function (o){
                            o.oddEven = oddEven;
                            if(oddEven == "odd") oddEven = "even";
                            else oddEven = "odd";
                            tableRows.push(o);
                        })

                        self.globalProfitDataTable = JSON.parse(JSON.stringify(tableRows));

                    } else {
                        this.isTaxHaven = true;
                        this.taxHavenText = "Tax haven country | " + self.selectedYear;

                        var tableRows = [];
                        tableRows.push({
                            id: "corp_tax_gain", label: "Revenue collected on shifted profits<br />(% of total corporate tax revenue)", value: UTILS.formatNumber(self.countryDBDataset.indicators["corp_tax_gain"].counterparts["World"].years[self.selectedYear].value, 2, "%")
                        })

                        if(self.DBProfitShiftingTaxHavenTooltipData[self.countryTooltipData.id] != undefined && self.DBProfitShiftingTaxHavenTooltipData[self.countryTooltipData.id].years[self.selectedYear] != undefined){
                            tableRows.push({
                                id: "tax_1", label: "Tax rate on shifted profits", value: UTILS.formatNumber(self.DBProfitShiftingTaxHavenTooltipData[self.countryTooltipData.id].years[self.selectedYear].corporateETR, 2, "%")
                            })
                        }

                        tableRows.push({
                            id: "shifted_profits", label: "Shifted profits ($, Bln)", value: UTILS.formatNumber(self.countryDBDataset.indicators["shifted_profits"].counterparts["World"].years[self.selectedYear].value, 2)
                        })
                        tableRows.push({
                            id: "tax_won", label: "Tax revenue gain from shifted profits ($, Bln)", value: UTILS.formatNumber(self.countryDBDataset.indicators["tax_won"].counterparts["World"].years[self.selectedYear].value, 2)
                        })

                        if(self.DBProfitShiftingTaxHavenTooltipData[self.countryTooltipData.id] != undefined && self.DBProfitShiftingTaxHavenTooltipData[self.countryTooltipData.id].years[self.selectedYear] != undefined){
                            tableRows.push({
                                id: "tax_2", label: "Total worldwide tax revenue loss due to<br />profit shifting to "+self.countryName+" ($, Bln)", value: UTILS.formatNumber(self.DBProfitShiftingTaxHavenTooltipData[self.countryTooltipData.id].years[self.selectedYear].corptaxrev, 2)
                            })
                        }

                        var dataYearsObj = self.countryDBDataset.indicators[self.indicatorObj.taxHavenID].counterparts[self.counterpartObj.id];
                        if(self.indicatorObj.smallUnit == "%"){
                            self.countryValue = UTILS.formatNumber(dataYearsObj.years[self.selectedYear].value, 2, "%");
                        } else {
                            self.countryValue = UTILS.formatNumber(dataYearsObj.years[self.selectedYear].value, 2);
                        }

                        self.countryValue = self.countryValue + self.indicatorObj.smallUnit;
                        this.countryHeadText = this.countryName + " collects " + tableRows[0].value + "% of their corporate tax receipts by artificially attracting "+ tableRows[1].value +" $ Bln. in profits from high-tax countries:"

                        self.globalProfitDataTableTaxHaven = JSON.parse(JSON.stringify(tableRows));
                    }
                } else if(this.datasetID == "offshore-financial"){

                    if(this.countryDB["Tax_haven_offshore_financial_wealth"] == "no" || (this.countryDB["Tax_haven_offshore_financial_wealth"] == "both" && !this.mapShowTaxHavens)){
                        this.taxHavenText = self.selectedYear;
                        var tableRows = [];
                        var denominatorValue = UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[self.countryDB.iso3].years[self.selectedYear]["gdp_USD_billion"];

                        var dataYearsObj = self.countryDBDataset.indicators["total"];
                        if(self.indicatorObj.smallUnit == "%"){
                            self.countryValue = UTILS.formatNumber((dataYearsObj.years[self.selectedYear].value/denominatorValue)*100, 2, "%");
                        } else {
                            self.countryValue = UTILS.formatNumber(dataYearsObj.years[self.selectedYear].value, 2);
                        }
                        self.countryValue = self.countryValue + self.indicatorObj.smallUnit;
                        this.countryHeadText = this.countryName + " holds offshore wealth equivalent to "+ this.countryValue + " " + self.indicatorObj.modalLabel;

                        tableRows.push({
                            id: "total", label: "All financial centres", value: UTILS.formatNumber(self.countryDBDataset.indicators["total"].years[self.selectedYear].value), valuePct: UTILS.formatNumber((self.countryDBDataset.indicators["total"].years[self.selectedYear].value/denominatorValue)*100, 2, "%")
                        })
                        tableRows.push({
                            id: "swiss", label: "Switzerland", value: UTILS.formatNumber(self.countryDBDataset.indicators["swiss"].years[self.selectedYear].value, 2, "%"), valuePct: UTILS.formatNumber((self.countryDBDataset.indicators["swiss"].years[self.selectedYear].value/denominatorValue)*100, 2, "%")
                        })
                        tableRows.push({
                            id: "europe", label: "European financial centres<br />(excl. Switzerland)", value: UTILS.formatNumber(self.countryDBDataset.indicators["europe"].years[self.selectedYear].value, 2, "%"), valuePct: UTILS.formatNumber((self.countryDBDataset.indicators["europe"].years[self.selectedYear].value/denominatorValue)*100, 2, "%")
                        })
                        tableRows.push({
                            id: "asian", label: "Asian financial centres", value: UTILS.formatNumber(self.countryDBDataset.indicators["asian"].years[self.selectedYear].value, 2, "%"), valuePct: UTILS.formatNumber((self.countryDBDataset.indicators["asian"].years[self.selectedYear].value/denominatorValue)*100, 2, "%")
                        })
                        tableRows.push({
                            id: "americ", label: "American financial centres", value: UTILS.formatNumber(self.countryDBDataset.indicators["americ"].years[self.selectedYear].value, 2, "%"), valuePct: UTILS.formatNumber((self.countryDBDataset.indicators["americ"].years[self.selectedYear].value/denominatorValue)*100, 2, "%")
                        })
                        self.offshoreFinancialDataTable = JSON.parse(JSON.stringify(tableRows));
                    } else {
                        this.isTaxHaven = true;
                        this.taxHavenText = self.selectedYear;

                        var tableRows = [];
                        var denominatorValue = UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[self.countryDB.iso3].years[self.selectedYear]["gdp_USD_billion"];

                        var dataYearsObj = self.countryDBDataset.indicators["total_attracted"];

                        if(dataYearsObj.years[self.selectedYear].value == "nodata"){
                            self.hasData = false;
                            return;
                        }

                        if(self.indicatorObj.smallUnit == "%"){
                            self.countryValue = UTILS.formatNumber((dataYearsObj.years[self.selectedYear].value/denominatorValue)*100, 2, "%");
                        } else {
                            self.countryValue = UTILS.formatNumber(dataYearsObj.years[self.selectedYear].value, 2);
                        }
                        self.countryValue = self.countryValue + self.indicatorObj.smallUnit;
                        

                        var havenGroup = "";
                        if(this.countryDB.taxHavenGroup == "europe"){
                            havenGroup = "European havens";
                        } else if(this.countryDB.taxHavenGroup == "americ"){
                            havenGroup = "American havens";
                        } if(this.countryDB.taxHavenGroup == "asian"){
                            havenGroup = "Asian havens";
                        }

                        this.countryHeadText = this.countryName + " attracts offshore wealth equivalent to "+ this.countryValue + " " + self.indicatorObj.modalLabelTaxHaven + ".";

                        var groupHosting = {
                            "World": {total: 0, GDP: 0, label: "World"},
                            "Europe and Central Asia": {total: 0, GDP: 0, label: "Europe and Central Asia"},
                            "Middle East and North Africa": {total: 0, GDP: 0, label: "Middle East and North Africa"},
                            "South Asia": {total: 0, GDP: 0, label: "South Asia"},
                            "Latin America and Caribbean": {total: 0, GDP: 0, label: "Latin America and Caribbean"},
                            "Sub-Saharan Africa": {total: 0, GDP: 0, label: "Sub-Saharan Africa"},
                            "East Asia and Pacific": {total: 0, GDP: 0, label: "East Asia and Pacific"},
                            "North America": {total: 0, GDP: 0, label: "North America"},
                        }
                        _.each(UTILS.DB_FINANCIAL, function (o, countryID){
                            if(UTILS.DB_COUNTRIES_OBJ[countryID] != undefined){
                                var countryRegion = UTILS.DB_COUNTRIES_OBJ[countryID].regionname;
                                if(groupHosting[countryRegion] != undefined){
                                    var denominatorObj = UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[countryID].years[self.selectedYear];
                                    if(denominatorObj["gdp_USD_billion"] != "nodata"){
                                        groupHosting[countryRegion].total += o.indicators[self.countryDB.taxHavenGroup].years[self.selectedYear].value;
                                        groupHosting["World"].total += o.indicators[self.countryDB.taxHavenGroup].years[self.selectedYear].value;
                                        groupHosting["World"].GDP += denominatorObj["gdp_USD_billion"];
                                        groupHosting[countryRegion].GDP += denominatorObj["gdp_USD_billion"];
                                    }
                                    
                                } else {
                                    console.log("not found", countryID, countryRegion)
                                }
                            }
                        })

                        _.each(groupHosting, function (o){
                            o.pctGDP = (o.total / o.GDP) * 100
                        });

                        _.each(groupHosting, function (o, groupID){
                            tableRows.push({
                                id: groupID, label: o.label, value: UTILS.formatNumber(o.total, 2), valuePct: UTILS.formatNumber(o.pctGDP, 2, "%")
                            })
                        })
                        self.offshoreFinancialDataTableTaxHaven = JSON.parse(JSON.stringify(tableRows));
                    }
                } else if(this.datasetID == "offshore-real-estate"){
                    this.taxHavenText = "Real estate owned in London, Paris, Côte d'Azur, Dubai, Singapore, Amsterdam and Oslo as a share of GDP (in %) | " + this.selectedYear;
                    var tableRows = [];

                    this.countryHeadText = "";

                    if(self.indicatorObj.smallUnit == "%"){
                        self.countryValue = UTILS.formatNumber(countryMapData.years[self.selectedYear].value, 2, "%");
                    } else {
                        self.countryValue = UTILS.formatNumber(countryMapData.years[self.selectedYear].value, 2);
                    }
                    this.countryValue = self.countryValue + self.indicatorObj.smallUnit;

                    var denominatorObj = UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[self.countryDB.iso3].years[this.selectedYear];

                    var oddEven = "even";
                    _.each(self.countryDBDataset.indicators["Aggregate (in USD billions)"].years[self.selectedYear], function (cityObj, cityLabel){
                        var cityTotalValue = UTILS.DB_REALESTATE_CITIES[cityLabel].total;
                        var ofCityToal = self.countryDBDataset.indicators["of_city_total"].years[self.selectedYear][cityLabel].value;
                        tableRows.push({
                            id: cityLabel,
                            oddEven: oddEven,
                            label: cityLabel,
                            data: [UTILS.formatNumber((cityObj.value/denominatorObj.gdp_USD_billion)*100, 2), UTILS.formatNumber(cityObj.value,2), UTILS.formatNumber((ofCityToal), 2, '%')]
                        })
                        if(oddEven == "odd") oddEven = "even";
                        else oddEven = "odd";
                    })

                    self.offshoreRealEstateDataTable = JSON.parse(JSON.stringify(tableRows))
                } else if(this.datasetID = "effective-tax"){
                    this.taxHavenText = "Effective capital tax rate (in %) | " + this.selectedYear;
                    this.countryHeadText = "";

                    if(countryMapData.years[self.selectedYear].value == "nodata"){
                        self.hasData = false;
                        return;
                    }

                    if(self.indicatorObj.smallUnit == "%"){
                        self.countryValue = UTILS.formatNumber(countryMapData.years[self.selectedYear].value, 2, "%");
                    } else {
                        self.countryValue = UTILS.formatNumber(countryMapData.years[self.selectedYear].value, 2);
                    }
                    this.countryValue = self.countryValue + self.indicatorObj.smallUnit;

                    var countryRegion = this.countryDB.regionname;
                    var countryIncomeLevel = this.countryDB.incomelevelname;
                    var tableRows = [];

                    tableRows.push({
                        label: "Labor ETR",
                        oddEven: "even",
                        data: [
                            UTILS.formatNumber(self.countryDBDataset.indicators["Labor_tax_rate"].years[self.selectedYear].value, 2, "%"),
                            UTILS.formatNumber(self.DBEffectiveTax["country-average"][self.countryTooltipData.id]["Labor_tax_country_average"] * 100, 2, "%"),
                            UTILS.formatNumber(self.DBEffectiveTax["region-average"][countryRegion].years[self.selectedYear]["Labor_tax_region_average"] * 100, 2, "%"),
                            UTILS.formatNumber(self.DBEffectiveTax["income-average"][countryIncomeLevel].years[self.selectedYear]["Labor_tax_income_average"], 2, "%")
                        ]
                    })

                    tableRows.push({
                        label: "Capital ETR",
                        oddEven: "odd",
                        data: [
                            UTILS.formatNumber(self.countryDBDataset.indicators["Capital_tax_rate"].years[self.selectedYear].value, 2, "%"),
                            UTILS.formatNumber(self.DBEffectiveTax["country-average"][self.countryTooltipData.id]["Capital_tax_country_average"] * 100, 2, "%"),
                            UTILS.formatNumber(self.DBEffectiveTax["region-average"][countryRegion].years[self.selectedYear]["Capital_tax_region_average"] * 100, 2, "%"),
                            UTILS.formatNumber(self.DBEffectiveTax["income-average"][countryIncomeLevel].years[self.selectedYear]["Capital_tax_income_average"], 2, "%")
                        ]
                    })

                    tableRows.push({
                        label: "Corporate ETR",
                        oddEven: "even",
                        data: [
                            UTILS.formatNumber(self.countryDBDataset.indicators["Corporate_tax_rate"].years[self.selectedYear].value, 2, "%"),
                            UTILS.formatNumber(self.DBEffectiveTax["country-average"][self.countryTooltipData.id]["Corporate_tax_country_average"] * 100, 2, "%"),
                            UTILS.formatNumber(self.DBEffectiveTax["region-average"][countryRegion].years[self.selectedYear]["Corporate_tax_region_average"] * 100, 2, "%"),
                            UTILS.formatNumber(self.DBEffectiveTax["income-average"][countryIncomeLevel].years[self.selectedYear]["Corporate_tax_income_average"], 2, "%")
                        ]
                    })

                    tableRows.push({
                        label: "Tax to NDP",
                        oddEven: "odd",
                        data: [
                            UTILS.formatNumber(self.countryDBDataset.indicators["Total_tax_NDP"].years[self.selectedYear].value, 2, "%"),
                            UTILS.formatNumber(self.DBEffectiveTax["country-average"][self.countryTooltipData.id]["Total_tax_country_average"] * 100, 2, "%"),
                            UTILS.formatNumber(self.DBEffectiveTax["region-average"][countryRegion].years[self.selectedYear]["Total_tax_region_average"] * 100, 2, "%"),
                            UTILS.formatNumber(self.DBEffectiveTax["income-average"][countryIncomeLevel].years[self.selectedYear]["Total_tax_income_average"], 2, "%")
                        ]
                    })

                    this.effectiveTaxDataTable = JSON.parse(JSON.stringify(tableRows));

                    var tableRows2 = [{
                        label: "% of Total",
                        oddEven: "even",
                        data:[
                            
                            UTILS.formatNumber(self.DBEffectiveTax["share-revenue"][self.countryTooltipData.id].years[self.selectedYear]["Share_personal_tax_individual"], 2, "%"),
                            UTILS.formatNumber(self.DBEffectiveTax["share-revenue"][self.countryTooltipData.id].years[self.selectedYear]["Share_personal_tax_corporate"], 2, "%"),
                            UTILS.formatNumber(self.DBEffectiveTax["share-revenue"][self.countryTooltipData.id].years[self.selectedYear]["Share_payroll_tax"], 2, "%"),
                            UTILS.formatNumber(self.DBEffectiveTax["share-revenue"][self.countryTooltipData.id].years[self.selectedYear]["Share_property_tax"], 2, "%"),
                            UTILS.formatNumber(self.DBEffectiveTax["share-revenue"][self.countryTooltipData.id].years[self.selectedYear]["Share_indirect_tax"], 2, "%"),
                            UTILS.formatNumber(self.DBEffectiveTax["share-revenue"][self.countryTooltipData.id].years[self.selectedYear]["Share_other_tax"], 2, "%"),
                        ]}
                    ]

                    this.effectiveTaxDataTable2 = JSON.parse(JSON.stringify(tableRows2));
                }
            }
        },

        preventBubbling: function (){

        },

        closeModal: function (){
            this.$emit('closeMapModal');
        }
        
    },

    watch: {
        countryTooltipData: function (){
            if(this.countryTooltipData.id !== undefined){
                if(this.isShow) this.updateModal();
            }
        },

        datasetID: function (){
            if(this.isShow) this.updateModal();
        },

        isShow: function (){
            this.isDisplayed = this.isShow;
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~assets/scss/_variables.scss";
@import "~assets/scss/_browsers.scss";

#MapModal{
    .modal_closebt{
        position: absolute;
        right: 40px;
        top: 24px;
        height: 32px;
        border-radius: 32px;
        line-height: 32px;
        cursor: pointer;
        background: #164193;
        padding: 0px 36px 0 20px;
        &:after{
            content: "";
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translate(0, -50%);
            background: url("/images/close.svg") no-repeat 0 0;
            background-size: 100% 100%;
            width: 20px;
            height: 20px;
        }
        &:hover{
            background: #fff;
            color: #164193;
            &:after{
                background: url("/images/close-blue.svg") no-repeat 0 0;
                background-size: 100% 100%;
            }
        }
    }
    .modal_head{
        .head_title{
            font-size: 24px;
            font-weight: 400;
        }
        .head_taxhaven{
            font-size: 14px;
            color: #BAC6DF;
            margin-top: 8px;
        }
        .head_value{
            margin-top: 8px;
            font-size: 16px;
            line-height: 16px;
            .value_chip{
                width: 14px;
                height: 14px;
                border: 1px solid #fff;
                border-radius: 2px;
                display: inline-block;
                vertical-align: middle;
            }
            .value_text{
                color: #fff;
                font-weight: 700;
                display: inline-block;
                vertical-align: middle;
                margin-left: 9px;
            }
        }
        .head_text{
            font-size: 16px;
            font-weight: 700;
            margin-top: 10px;
        }
    }

    .table_effective_tax{
        .table_encart{
            height: 42px;
            line-height: 42px;
            text-transform: uppercase;
            color: #fff;
            font-size: 14px;
            text-align: center;
            background: #164193;
            border-radius: 8px 8px 0px 0px;
            &.encart2{
                margin-top: 24px;
            }
        }
        .table_data{
            margin-top: 10px;
            tr{
                th{
                    height: 60px;
                }
            }
            tr{
                td{
                    height: 42px;
                }
            }
        }
    }

    .modal_table{
        border-top: 3px solid #29264C;
        padding-top: 24px;
        margin-top: 10px;

        &[data-dataset="effective-tax"]{
            border: 0px solid;
            padding-top: 0px;
        }

        .table_data{
            border-collapse: collapse;
            width: 100%;
            &.twocols{
                tr{
                    height: 44px;
                    td{
                        width: 50%;
                        font-size: 14px;
                        line-height: 18px;
                        &.bordered{
                            border-right: 1px solid #2E5BB0;
                        }
                    }
                    &:nth-child(odd){
                        background: #29264C;
                    }
                }
            }

            &.threecols{
                tr{
                    td{
                        width: 33% !important;
                    }
                    &:nth-child(even){
                        background: #29264C  !important;
                    }
                    &:nth-child(odd){
                        background: transparent !important;
                    }
                }
            }

            &.fivecols{
                tr{
                    td, th{
                        width: 20% !important;
                    }
                }
            }

             &.sevencols{
                tr{
                    td, th{
                        width: 14.28% !important;
                    }
                }
            }

            tr{
                height: 24px;
                line-height: 24px;
                &.head{
                    height: 50px;
                    th{
                        text-align: center;
                    }
                }
                th.cell{
                    width: 25%;
                    padding: 4px 16px;
                    font-size: 14px;
                    line-height: 18px;
                    vertical-align: top;
                    &.bordered{
                        border-right: 1px solid #2E5BB0;
                    }
                }
                td{
                    padding: 0 16px;
                    font-size: 14px;
                    &.bordered{
                        border-right: 1px solid #2E5BB0;
                    }
                    &.datavalue{
                        text-align: center;
                    }
                }
                &[data-type="group"]{
                    background: #164193;
                    td.label{
                        text-transform: uppercase;
                    }
                    &[data-inc="0"], &[data-inc="1"]{
                        border-bottom: 1px solid #191637;
                    }
                }
                &[data-oddeven="even"]{
                    background: #29264C;
                }

                &.row{
                    &:hover{
                        background: #fff !important;
                        color: #191637 !important;
                        td{
                            color: #191637 !important;
                        }
                    }
                }
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// components/MapModal.vue